
import { RSAA } from 'redux-api-middleware';
import config from 'config';
import { format } from 'date-fns';


export const getPAWGroupList = (pageSize, page, sorted, filtered) => (dispatch, getState) => {

  const transformedFiltered = filtered.map(f => {
    if (f.id === 'switchCreationDate' && Array.isArray(f.value)) {
      return {
        ...f,
        value: f.value.map(v => {
          // Convert - Date object → 'yyyy-MM-dd' format for Backend
          return format(v, 'yyyy-MM-dd');
        }),
      };
    }
    return f;
  });

  const rsaaObject = {
    [RSAA]: {
      endpoint: `${config.apiRoot}/paw-group/list`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ pageSize, page, sorted, filtered: transformedFiltered }),
      types: [
        'GET_PAW_GROUPS_REQUEST',
        {
          type: 'GET_PAW_GROUPS_SUCCESS',
          payload: async (action, state, res) => {
            const data = await res.json();
              const restoredFiltered = transformedFiltered.map(f => {
              if (f.id === 'switchCreationDate' && Array.isArray(f.value)) {
                return {
                  ...f,
                  value: f.value.map(v => {
                      // Convert back — 'yyyy-MM-dd' → Date object for UI
                      return new Date(v);
                  }),
                };
              }
              return f;
            });
            return { pageSize: pageSize, sorted: sorted, filtered: restoredFiltered,...data };
          }
        },
        'GET_PAW_GROUPS_FAILURE'
      ],
    }
  }

  return dispatch(rsaaObject);
}

export const refreshPawGroupList = () => (dispatch, getState) => {
  const {sorted,filtered,pageSize} = getState().pawGroup;
  console.log('filterr', sorted,filtered,pageSize)
  dispatch(getPAWGroupList(pageSize, 0, sorted, filtered))
}
